import { useCallback } from 'react';

import { mapLinkVacancies } from '../../../services/vacancies/vacancies.utils';
import { VacanciesResponseInterface } from '../../../types/vacancies.types';
import { isInIframe } from '../../../utils/iframe';
import { useLanguage } from '../../useLanguage';
import { useToggles } from '../../useToggles';
import { ApiResponseTransformer } from '../useApiService';

export const useVacanciesLinkTransformer =
  (): ApiResponseTransformer<VacanciesResponseInterface> => {
    const { language } = useLanguage();
    const {
      ops: { jobDetailUrls },
    } = useToggles();

    return useCallback(
      (response?: VacanciesResponseInterface) =>
        mapLinkVacancies(language, response, isInIframe(), jobDetailUrls),
      [language, jobDetailUrls]
    );
  };
